import { ESPType } from "./enum";

export const COOKIE_AUTH_TOKEN = "token";

export const DATE_FORMAT = 'DD/MM/YYYY';
export const DATE_FORMAT_YY = 'DD/MM/YY';
export const DATE_FORMAT_YYYY_MM_DD = 'YYYY/MM/DD';
export const DATE_FORMAT_API = 'YYYY-MM-DD';
export const DATE_FORMAT_DDMMYYYY_HHMMSS_API = 'YYYY-MM-DD HH:mm:ss';
export const DATE_FORMAT_DDMMYYYY_HHMMSS = 'DD/MM/YYYY HH:mm:ss';

export const YesNoOptions = [
    { label: "Yes", value: "true" },
    { label: "No", value: "false" },
];

export const EnableDisableOptions = [
    { label: "Enabled", value: "true" },
    { label: "Disabled", value: "false" },
];

export const CheckOptions = [
    { label: "Check", value: "true" },
    { label: "UnCheck", value: "false" },
];

export const ESPTypeOptions = [
  { label: "AP", value: ESPType.COMMON },
  { label: "Flight", value: ESPType.FLIGHT },
  { label: "Tour Event", value: ESPType.TOUR_EVENT },
  { label: "Other", value: ESPType.OTHER_SUPPLIER },
];

export const BOOKING_NO_PATTERN = /^(?:A\d{5}|(?:EU|UK|RW|TE)\d{6})$/;

export const ENV_STAGING = "staging";
